import React, {useEffect, useState} from 'react'
import {Box, Stack, Typography} from '@mui/material';
import {Video} from './';
import { useParams } from 'react-router-dom';
import { fetchAPI } from '../utils/fetchAPI';

const SearchFeed = () => {
  const [videos, setVideos] = useState()
  // Take the paramter from the url sent here 
  const {searchTerm} = useParams();

  useEffect(() => {
    
    // Search for shit
    const fetchSearchData = async (searchTerm) => {
      setVideos(null)
      const data = await fetchAPI(`search?q=${searchTerm}&part=snippet`)
      setVideos(data); 
    }

    fetchSearchData(searchTerm);
  
    
  }, [searchTerm])
  

  return (
    <Stack
      sx={{
        height: '92vh'
      }}
    >
      <Box p={2} sx={{ overflowY: 'auto', backgroundColor: '#FFF5E4', flex: 2}}>
        <Typography variant={'h4'} fontWeight="bold" mb={2} sx={{color: '#850E35'}}>
         {searchTerm} <span style={{color: '#EE6983'}}>Video</span>
        </Typography>
        <Video videos={videos} />
      </Box>
    </Stack>
  )
}

export default SearchFeed;